import { Link } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { SiteHeader } from "@/components/dashboard/site-header";

export default function ComingSoonPage() {
	return (
		<main className="flex-1">
			<SiteHeader />
			<div className="container py-12 px-4 md:px-6">
				<div className="mx-auto max-w-3xl">
					<Card className="border bg-background">
						<CardContent className="p-8 md:p-10">
							<div className="space-y-3 text-center">
								<span className="inline-flex items-center rounded-full bg-amber-100 px-3 py-1 text-xs font-medium text-amber-900">
									New feature
								</span>
								<h1 className="text-3xl md:text-4xl font-bold tracking-tight">
									Coming Soon
								</h1>
								<p className="text-sm md:text-base text-muted-foreground">
									We’re putting the final touches on this
									page. Check back soon.
								</p>
							</div>

							<div className="mt-8 flex items-center justify-center gap-3">
								<Button
									asChild
									className="bg-yellow-500 hover:bg-yellow-600 text-black">
									<Link to="/">Go Home</Link>
								</Button>
								<Button asChild variant="outline">
									<Link to="/dashboard">
										Back to Dashboard
									</Link>
								</Button>
							</div>
						</CardContent>
					</Card>
				</div>
			</div>
		</main>
	);
}
